import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";
import { ScenarioField } from "../types/field";

export interface ReplaceScenarioFieldsRequest {
  scenarioId: string;
  fields: ScenarioField[];
}

export interface ReplaceScenarioFieldsResponse {
  fields: ScenarioField[];
}

const replaceScenarioFields = async (
  request: ReplaceScenarioFieldsRequest
): Promise<ReplaceScenarioFieldsResponse> => {
  const response = await axios.put<ReplaceScenarioFieldsResponse>(
    `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario/${request.scenarioId}/fields`,
    {
      fields: request.fields.map((f) => ({
        field: f.field,
        name: f.name,
        product: f.product ?? null,
        unit: f.unit ?? null,
        syncField: f.syncField ?? null
      }))
    }
  );

  return response.data;
};

export const useReplaceScenarioFields = () => {
  const queryClient = useQueryClient();
  return useMutation<
    ReplaceScenarioFieldsResponse,
    AxiosError,
    ReplaceScenarioFieldsRequest
  >(replaceScenarioFields, {
    onMutate: async (request) => {
      // Cancel in-flight fetches so they don't overwrite optimistic state mid-replace
      await queryClient.cancelQueries(["scenarioFields", request.scenarioId]);
    },
    onSuccess: (data, request) => {
      // Update cache with the server-authoritative result — no refetch needed
      queryClient.setQueryData(["scenarioFields", request.scenarioId], {
        fields: data.fields
      });
    }
  });
};
